var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 22,
    viewBox: "0 0 70 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.94 16.89L24.94 22H31.37C32.9564 21.8926 34.4398 21.176 35.51 20C36.6498 18.7619 37.2692 17.1325 37.24 15.45C37.2041 14.6687 36.981 13.9076 36.5894 13.2306C36.1978 12.5536 35.6493 11.9807 34.99 11.56L27.86 7.19C27.6579 7.05004 27.4875 6.86902 27.36 6.65881C27.2325 6.44861 27.1507 6.2139 27.12 5.96997C27.12 5.34997 27.48 4.83001 27.94 4.82001C28.4 4.81001 36.14 4.82001 36.14 4.82001L34.24 -0.0200195H27.41C26.1087 0.0097082 24.8564 0.482424 23.86 1.32001C23.3244 1.8367 22.902 2.45906 22.6197 3.14764C22.3374 3.83623 22.2013 4.57603 22.22 5.32001C22.1971 6.33119 22.4008 7.33464 22.8161 8.2569C23.2314 9.17916 23.8477 9.99681 24.62 10.65C26.14 11.65 30.14 14.04 30.53 14.27C30.92 14.5 31.67 14.91 31.68 15.56C31.69 16.21 31.28 16.88 30.68 16.88L22.94 16.89Z",
    fill: "#D0112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.94 16.89L39.94 22H46.37C47.9534 21.8922 49.4336 21.1754 50.5 20C51.6425 18.7629 52.2655 17.1337 52.24 15.45C52.2017 14.6693 51.9776 13.9091 51.5862 13.2325C51.1949 12.5559 50.6476 11.9825 49.99 11.56C48.45 10.63 42.99 7.27 42.85 7.19C42.651 7.04772 42.4835 6.86591 42.3579 6.65601C42.2323 6.4461 42.1513 6.21257 42.12 5.96997C42.12 5.34997 42.48 4.83001 42.93 4.82001C43.38 4.81001 51.14 4.82001 51.14 4.82001L49.3 -0.0200195H42.4701C41.1687 0.0097082 39.9164 0.482424 38.92 1.32001C38.3842 1.83608 37.9624 2.45856 37.6817 3.14746C37.4009 3.83637 37.2675 4.57644 37.29 5.32001C37.265 6.3315 37.4677 7.33565 37.8831 8.25824C38.2986 9.18083 38.9161 9.99822 39.69 10.65C41.2 11.65 45.21 14.04 45.6 14.27C45.99 14.5 46.74 14.91 46.75 15.56C46.76 16.21 46.35 16.88 45.75 16.88L37.94 16.89Z",
    fill: "#D0112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3199 21.9098H56.8799L60.7299 11.8798L62.7199 16.8498H59.9699L61.9599 21.9098H69.9999L60.6899 0.0898438L51.3199 21.9098Z",
    fill: "#D0112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.380005 20.9802L0 21.9202H8.07001C8.68408 21.9236 9.28841 21.7667 9.8233 21.465C10.3582 21.1634 10.8051 20.7274 11.12 20.2002L0.380005 20.9802Z",
    fill: "#D0112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1301 17.7298L12.7701 16.0498L2.04005 16.8198L1.68005 17.7298H12.1301Z",
    fill: "#D0112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22995 18.8501L0.829956 19.8501H11.3099L11.3999 19.6401L11.9999 18.0801L1.22995 18.8501Z",
    fill: "#D0112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.33 0.0898438L8.20999 14.3398L2.90999 14.6498L2.48999 15.6998H12.91L14.37 11.8798L16.37 16.8498H13.62L15.6 21.9098H23.65L14.33 0.0898438Z",
    fill: "#D0112B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFLogo);
export default __webpack_public_path__ + "static/media/fLogo.208e9f284074f38e169ebd09be01affd.svg";
export { ForwardRef as ReactComponent };